export default __webpack_public_path__ + "static/media/met-before-bg.fadc1612.png";